import type { AddLocationLocationType } from "@/Shared/Types/locationTypes";
import { LocationType } from "@freightsimple/generated-dashboard-openapi-client/models/LocationType";
import moment from "moment";
import { emptyLocationErrorMessages } from "./locationsEmptyErrorMessages";
import type { LocationErrors } from "./locationsErrorMessagesForLocation";
import { locationsErrorMessagesForLocation } from "./locationsErrorMessagesForLocation";

export function locationsErrorMessagesForPickupLocation(
  pickupDate: string,
  pickupLocation: AddLocationLocationType,
): LocationErrors {
  const checkHoursAreValidForAPickupToday =
    pickupDate === moment().format("YYYY-MM-DD");

  const errorMessages = locationsErrorMessagesForLocation(
    pickupLocation,
    checkHoursAreValidForAPickupToday,
  );

  return errorMessages;
}

export function warningMessagesForPickupLocation(
  pickupLocation: AddLocationLocationType,
): LocationErrors {
  const errorMessages = emptyLocationErrorMessages();

  if (
    pickupLocation.locationType === LocationType.Residential &&
    !pickupLocation.accessorials.includes("LOGISTICS_LIFT_GATE_REQUIRED")
  ) {
    return {
      ...errorMessages,
      locationType: "Typically residential pickups require lift gates",
    };
  }

  return errorMessages;
}
